import { GET_DATA_INFO } from './constants'

const data = {
  
}

function reducer(state=data,action) {

  switch (action.type) {
    case GET_DATA_INFO:
      return {...action.data}  
    default:
      return state
  }
}

export default reducer;